import { render, staticRenderFns } from "./TransportSolicCardSkeleton.vue?vue&type=template&id=25a499f0&scoped=true&"
import script from "./TransportSolicCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./TransportSolicCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TransportSolicCardSkeleton.vue?vue&type=style&index=0&id=25a499f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a499f0",
  null
  
)

export default component.exports